import { Button, Layout, Card, Form, Input, Select, message } from 'antd'
import { Loading } from 'Components'
import { useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router'
import { connect } from 'react-redux'
import { setBranches } from 'Actions/branches'

NewBranch = ({ branches, setBranches }) ->

  [loading, setLoading] = useState(false)
  [feedback, setFeedback] = useState({ status: undefined, msg: undefined })

  history = useHistory()
  { params: { spaceId }} = useRouteMatch()

  useEffect(->
    (->
      setLoading(true)
      setBranches(
        _.filter(await Weaver.Branch.list(), (branch) ->
            branch.id() isnt '$config'
        )
      )
      setLoading(false)
    )()
    undefined
  , [])

  createBranch = (data) ->
    setLoading(true)
    try
      message.info({
        key: 'creating-new-branch'
        duration: 0
        content: 'Creating branch. This could take several minutes.'
      })
      baseBranch = await Weaver.Branch.load(data.sourceBranch) if data.sourceBranch?
      newBranch = new Weaver.Branch(
        _.camelCase(data.branchName),
        data.branchName,
        { baseBranch: baseBranch }
      )
      await newBranch.create()
      message.destroy('creating-new-branch')
      history.push("/#{spaceId}/branches")
    catch e
      console.error(e)
      setFeedback({
        status: 'error'
        msg: e.message
      })

  if loading
    <Loading />
  else
    <Layout style={{ padding: '16px' }}>
      <Card>
        <Form
          layout='vertical'
          colon={false}
          onFinish={createBranch}
          initialValues={{
            sourceBranch: 'main'
          }}
        >
          <Form.Item
            label="Branch name"
            name="branchName"
            rules={[{ required: true, message: 'Name is required' }]}
            validateStatus={feedback.status}
            help={feedback.msg}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Create from"
            name="sourceBranch"
          >
            <Select>
              <Select.Option key="empty-parent-branch" value={null}>
                Create branch without parent
              </Select.Option>
              {
                branches.map((branch) ->
                  <Select.Option key={branch.id()} value={branch.id()}>
                    { branch.name() }
                  </Select.Option>
                )
              }
            </Select>
          </Form.Item>
          <Form.Item>
            <Button
              htmlType="submit"
              type='primary'
            >
              Create branch
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Layout>

export default connect(({ branches }) ->
  { branches: branches.branches }
, { setBranches })(NewBranch)
